import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { Icon } from '../Icon';
import { Text } from '../Typography';

export const AuthContainer = styled.div`
  position: relative;
  flex-flow: column nowrap;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 100%;
  padding: ${toRem(theme.space['3xl'])} 0;

  @media (min-width: ${theme.breakpoint.small}px) {
    justify-content: space-between;
  }
`;

export const AuthInviteContainer = styled(AuthContainer)`
  height: auto;

  @media (min-width: ${theme.breakpoint.small}px) {
    min-height: 100vh;
  }
`;

export const AuthContent = styled.section`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-grow: 1;
  }

  &.email-verify {
    @media (min-width: ${theme.breakpoint.med}px) and (max-width: ${theme.breakpoint.large}px) {
      width: unset;

      header > button {
        left: 0;
      }
    }
  }
`;

export const AuthContentInner = styled.div`
  position: relative;
  align-self: center;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space['2xl'])};
  justify-items: center;
  width: 100%;
  max-width: ${toRem(382)};
`;

export const AuthContentLayout = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)};
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${toRem(300)};
`;

export const AuthFieldset = styled.fieldset`
  margin-bottom: ${toRem(theme.space['2xl'])};
`;

export const AuthColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${toRem(theme.space.md)};
  width: 100%;
`;

export const AuthConsentGroup = styled.fieldset`
  margin-bottom: ${toRem(theme.space.xl)};
`;

export const AuthLegalText = styled(Text).attrs({
  size: 'small',
})`
  text-align: center;
  color: ${theme.color.neutral[700]};
`;

export const AuthButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.md)};
  justify-items: center;
  width: 100%;
  max-width: ${toRem(300)};
`;

export const AuthSSOInputLayout = styled.div`
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const AuthSSOEmailIcon = styled(Icon)`
  width: ${toRem(15)};
  height: ${toRem(15)};
  margin-right: ${toRem(theme.space.md)};
`;

export const AuthOrContainer = styled.div.attrs({
  'aria-hidden': true,
})`
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.medium};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  color: ${theme.color.neutral[700]};

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 40%;
    border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    width: 40%;
    border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  }
`;

export const AuthInviteButtonWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
